"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirestoreAdminApiVersionsProduct = exports.ROLE_DISPLAY_NAMES = exports.FirestoreAdminUserRole = exports.SHEET_PREFERENCES_SUBMIT_MODES = void 0;
exports.SHEET_PREFERENCES_SUBMIT_MODES = [
    "process-new-sheets",
    "review-failed-submissions",
    "review-reported-sheets",
];
var FirestoreAdminUserRole;
(function (FirestoreAdminUserRole) {
    FirestoreAdminUserRole["Admin"] = "admin";
    FirestoreAdminUserRole["MobileEditor"] = "mobile:editor";
    FirestoreAdminUserRole["JobsEditor"] = "jobs:editor";
    FirestoreAdminUserRole["SheetSubmitter"] = "sheet:submitter";
    FirestoreAdminUserRole["SheetUploader"] = "sheet:uploader";
    FirestoreAdminUserRole["ActivismOrganiser"] = "activism:organiser";
    FirestoreAdminUserRole["ActivismAdmin"] = "activism:admin";
})(FirestoreAdminUserRole = exports.FirestoreAdminUserRole || (exports.FirestoreAdminUserRole = {}));
exports.ROLE_DISPLAY_NAMES = {
    admin: "Admin",
    "mobile:editor": "Mobilapp: szerkesztő",
    "jobs:editor": "Jobs: editor",
    "sheet:submitter": "Adatbevitel: gépelő",
    "sheet:uploader": "Adatbevitel: feltöltő",
    "activism:organiser": "Aktivizmus: szervező",
    "activism:admin": "Aktivizmus: admin",
};
var FirestoreAdminApiVersionsProduct;
(function (FirestoreAdminApiVersionsProduct) {
    FirestoreAdminApiVersionsProduct["Mobile"] = "mobile";
})(FirestoreAdminApiVersionsProduct = exports.FirestoreAdminApiVersionsProduct || (exports.FirestoreAdminApiVersionsProduct = {}));
//# sourceMappingURL=adminApi.js.map